export default __webpack_public_path__ + "static/media/kafair-indonesia.09f96d7f.jpg";